export default __webpack_public_path__ + "static/img/no-images.07defdc.jpg";